import React from 'react';
import './PopupupScreen.css'; // Import external CSS
import { RiLogoutCircleRLine } from "react-icons/ri";
import axios from "axios";
import API_URL from "./Config";
import { useNavigate } from "react-router-dom";
import { clearStoredMenuItems } from "./services/menuService";

const PopupupScreen = ({ onClose }) => {
  const navigate = useNavigate();

      const handleLogout = () => {
        const authKey = localStorage.getItem("authKey");
    
        axios
          .post(`${API_URL}/api/logout`, null, {
            headers: {
              Authorization: authKey,
            },
          })
          .then((response) => {
            console.log(response.data.message);
            localStorage.removeItem("authKey");
            localStorage.removeItem("userName");
            localStorage.removeItem("preferred_language");
            localStorage.removeItem("selectedLanguage");
            localStorage.removeItem("userState");
            localStorage.removeItem("admin");
            localStorage.removeItem("role");
            localStorage.removeItem("district_id");
            localStorage.removeItem("sub_division_id");
            localStorage.removeItem("station_id");
            localStorage.removeItem("selectedFilter");
            localStorage.removeItem("selectedOption");
            localStorage.removeItem("filter_option");
            clearStoredMenuItems();
    
            navigate("/login");
          })
          .catch((error) => {
            console.error("Error during logout:", error.response.data.message);
          });
      };
  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h2 className="popup-title">Subscription Ended</h2>
        <p className="popup-message">
          We regret to inform you that your subscription has ended. Please contact customer support for assistance.
        </p>
        <div className="popup-contact-info">
          <p>If you need help, please contact us:</p>
          <p className="popup-phone-number">
            <strong>Phone: </strong>+919724656361
          </p>
          {/* <p className="popup-email">
            <strong>Email: </strong>support@yourcompany.com
          </p> */}
        </div>
     
        <button className="log-out-btn-s" onClick={handleLogout}>
                            Log Out
                            <RiLogoutCircleRLine className="iconout" />
                          </button>
      </div>
    </div>
  );
};

export default PopupupScreen;
